import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { MastercardConfigurationCard } from './components/mastercard-configuration-card'
import { MastercardDescriptorCard } from './components/mastercard-descriptor-card'
import { MastercardFeaturesCard } from './components/mastercard-features-card'

interface MastercardProcessorDetailsPageProps {
    processor: ProcessorDetails
}

export const MastercardProcessorDetailsPage = ({ processor }: MastercardProcessorDetailsPageProps) => {
    return (
        <>
            <ProcessorHeader
                type="mastercard"
                processor={processor}
            />
            <ProcessorOverviewCard processor={processor} testModeWarningKey="mastercardTestModeWarning" />
            <ProcessorMetricsCard processor={processor} />
            <MastercardConfigurationCard processor={processor} />
            <MastercardDescriptorCard processor={processor} />
            <MastercardFeaturesCard />
        </>
    )
}

